
export default {
  name: 'AppInstagramIcon',
  props: {
    iconSize: { type: Number, default: 36 }
  }
};
